import React from 'react';

const Loader = () => {
    return (
        <div className="loader-gif">
            <img src={'/assets/images/loader.gif'} alt="loading icon" loading="lazy"/>
        </div>
    );
};

export default Loader;

